import React from "react";
import "./experienceNew.css";
import projectsData from "../../data/projectsData";

const Experience = () => {
  const experiences = projectsData.experience;

  return (
    <section className="experience-section" id="experience">
      <h2 className="section-title">EXPERIENCE</h2>
      <p className="section-intro">
        Professional experience of Shantanu Basumatary in full stack development
        and AI-focused software engineering roles.
      </p>
      <div className="experience-timeline">
        {experiences.map((exp) => (
          <div key={exp.id} className="experience-item">
            <div className="experience-date">
              <div className="experience-year">{exp.year}</div>
              <div className="experience-month">{exp.month}</div>
            </div>
            <div className="experience-dot"></div>
            <div className="experience-content">
              <h3 className="experience-title">{exp.title}</h3>
              <p className="experience-company">{exp.company}</p>
              <p className="experience-description">{exp.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experience;
